import store from "./store";

export const loadModuleStore = store;
